import { combineReducers } from 'redux'
import currentPage from './currentPage'

export default combineReducers({
  currentPage
})